const query = isPreview => `
{headerCollection(limit: 1, preview: ${isPreview}) {
  items {
    logoImg {
      altText
      imageDesktop {
        height
        description
        title
        width
        url
      }
      imageMobile {
        title
        width
        url
        description
        height
      }
    }
  }
}
}
`

module.exports = { query }
